import React, { useContext } from 'react';
import { AppDataContext } from 'contexts/appData';

const Deactivation = () => {

  const { api, CONFIG, getLang } = useContext(AppDataContext);
  const token = api.cookie._get(CONFIG.CACHE.TAGS.COOKIEAUTH);

  const baseUrl = `${CONFIG.HOST.authUrl}${getLang}/user/deleteuser`;
  const queryParams = new URLSearchParams({
    Continue: CONFIG.HOST.appUrl,
    Token: token
  }).toString();

  return (
      <iframe
        title='deactivation'
        className="w-100 h-100 border-0"
        src={`${baseUrl}?${queryParams}`}
      />
  );
};

export default Deactivation;